import secondaryComponents from "..";
import useReturnItemsTable from "./useReturnItemsTable";

const ReturnItemsTable = ({
  items = [],
  returnDetails,
  currencyCode = "NGN",
  className = "",
  style,
}) => {
  const { instance } = useReturnItemsTable({
    items,
    returnDetails,
    currencyCode,
  });

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    instance;

  return (
    <div className={className} style={style}>
      <secondaryComponents.TableHelper
        getTableProps={getTableProps}
        getTableBodyProps={getTableBodyProps}
        headerGroups={headerGroups}
        rows={rows}
        prepareRow={prepareRow}
        minHeight="auto"
      >
        <div className="py-4 text-center">
          <p className="mb-0 text-muted">
            No product items found for this return request.
          </p>
        </div>
      </secondaryComponents.TableHelper>
    </div>
  );
};

export default ReturnItemsTable;
